(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('activityGroupEditor', activityGroupEditor);

    function activityGroupEditor(config) {
        return {
            templateUrl: '/app/directives/activities/activity-group-editor.tpl.html',
            scope: {
                groups: '=',
                groupLevel: '=',
                hideExaminers: '=',
                catalogItems: '='
            },
            controllerAs: 'vm',
            bindToController: true,
            controller: ActivityGroupEditorController
        };

        function ActivityGroupEditorController($translate, logger) {
            var vm = this;
                        
            vm.classicalActivitySwitchEnabled = config.settings.classicalActivitySwitchEnabled === undefined ? true : config.settings.classicalActivitySwitchEnabled;

            vm.addItem = addItem;
            vm.addGroup = addGroup;
            vm.allowToggleOnOff = allowToggleOnOff;
            vm.deleteGroup = deleteGroup;
            vm.getActivities = getActivities;
            vm.getActivityIndex = getActivityIndex;
            vm.getGroupIndex = getGroupIndex;
            vm.getMaxOptionalActivities = getMaxOptionalActivities;
            vm.hideExaminersForActivity = hideExaminersForActivity;
            vm.isBlockActive = isBlockActive;
            vm.isEditorForActivity = isEditorForActivity;
            vm.moveActivity = moveActivity;
            vm.moveGroup = moveGroup;
            vm.removeItem = removeItem;
            vm.setGroupType = setGroupType;
            vm.toggleOnOff = toggleOnOff;
            vm.toggleOnOffBlock = toggleOnOffBlock;
            
            function addItem(group, type) {
                group.activities.push({ type: type });
            }

            function addGroup() {
                vm.groups.push({
                    groupType: 'compulsory',
                    groupLevel: vm.groupLevel,
                    groupEditable: true,
                    optionalCompulsoryNumber: 0,
                    activities: []
                });
            }

            function allowToggleOnOff(group) {
                if (group.groupLevel === vm.groupLevel) return false;
                if (vm.isIndividual) return false;
                if (config.settings.user.isAdmin) return true;
                return group.groupEditable;
            }
            
            function deleteGroup(group) {
                if (vm.groups) {
                    return vm.groups.splice(getGroupIndex(group), 1)[0];
                }
            }

            function getActivities(group, type) {
                return type ? _.filter(group.activities, item => { return item.type === type; }) : group.activities;
            }

            function getActivityIndex(activity, group) {
                return group.activities.indexOf(activity);
            }

            function getGroupIndex(group) {
                return vm.groups.indexOf(group);
            }

            function getMaxOptionalActivities(group) {
                var i = group.activities.length;
                return new Array(i === 0 ? 1 : i);
            }

            function hideExaminersForActivity(activity) {
                return activity.type === "peerassessment" ? true : vm.hideExaminers;
            }

            function isBlockActive(group) {
                return group.notApplicable === undefined || group.notApplicable === false ? true : false;
            }

            function isEditorForActivity(activity, editor) {
                var isEditor = false;
                switch (activity.type) {
                    case "protocol":
                    case "manual":
                        isEditor = editor === "link-activity-editor";
                        break;
                    case "classical":
                        isEditor = editor === "classical-activity-editor";
                        break;
                    case "elearning":
                        isEditor = editor === "elearning-activity-editor";
                        break;
                    case "skillslabtraining":
                    case "skillslabtest":
                    case "trainingonthejob":
                    case "writtentest":
                    case "practical":
                    case "peerassessment":
                        isEditor = editor === "test-activity-editor";
                        break;
                }
                return isEditor;
            }

            function moveActivity(activity, group, dir) {
                var idx = getActivityIndex(activity, group);
                var item = group.activities.splice(idx, 1)[0];

                if (dir === 'down') {
                    group.activities.splice(idx + 1, 0, item);
                }
                else {
                    group.activities.splice(idx - 1, 0, item);
                }
            }

            function moveGroup(group, dir) {
                var idx = getGroupIndex(group);
                var item = deleteGroup(group);

                if (dir === 'down') {
                    vm.groups.splice(idx + 1, 0, item);
                }
                else {
                    vm.groups.splice(idx - 1, 0, item);
                }
            }

            function removeItem(item, group) {
                group.activities.splice(group.activities.indexOf(item), 1);
                updateOptionalNumber(group);
            }

            function updateOptionalNumber(group) {
                if (group.groupType !== "optional") return;
                
                var maxOptionalActivities = getMaxOptionalActivities(group).length;
                if (group.optionalCompulsoryNumber > maxOptionalActivities) group.optionalCompulsoryNumber = maxOptionalActivities;
            }

            function setGroupType(group, groupType) {
                group.groupType = groupType;

                if (groupType !== 'optional') {
                    group.optionalCompulsoryNumber = 0;
                }
                else {
                    group.optionalCompulsoryNumber = 1;
                }
            }

            function toggleOnOff(item, group) {
                var setNotApplicable = item.notApplicable === undefined || item.notApplicable === false ? true : false;

                if (!setNotApplicable) {
                    item.notApplicable = false;
                    return;
                } else {
                    if (group.optionalCompulsoryNumber) {
                        var notApplicable = _.where(group.activities, { notApplicable: true });

                        if (group.activities.length - notApplicable.length > group.optionalCompulsoryNumber) {
                            item.notApplicable = true;
                        }
                        else {
                            logger.error($translate.instant('the_minimum_number_of_required_activities_is') + ' ' + group.optionalCompulsoryNumber);
                        }
                    } else {
                        item.notApplicable = true;
                    }

                    if (group.activities.length === _.where(group.activities, { notApplicable: true }).length) {
                        group.notApplicable = true;
                    }
                }
            }

            function toggleOnOffBlock(group) {
                group.notApplicable = isBlockActive(group);
                for (var i = 0; i < group.activities.length; i++) {
                    group.activities[i].notApplicable = group.notApplicable;
                }
            }
        }
    }
})();